import React, { useState, useContext } from "react"
import "./PayPages.css"

import EscapeRoomData from "../EscaperoomsPage/components/EscapeRoomData"
import { faLock, faSpinner } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import PageNotFound from "../PageNotFound/PageNotFound"
import { Helmet } from "react-helmet"
import { useParams } from "react-router"

import { AppContext } from "../shared/context/AppContext"

function PayPage() {
  const { language } = useContext(AppContext)
  const { linktoPar } = useParams()
  const room = EscapeRoomData.find((x) => x.linkto === linktoPar)
  const { id, price, players, title, titleEN, picName, themeColor } =
    room || {}

  const [email1, setEmail1] = useState("")
  const [email2, setEmail2] = useState("")
  const [naam, setNaam] = useState("")
  const [EMAlert, setEMAlert] = useState(false)
  const [algVW, setAlgVW] = useState(false)
  const [error, setError] = useState("")
  const [discountCode, setDiscountCode] = useState("")
  const [couponError, setCouponError] = useState("")
  const [discountAmount, setDiscountAmount] = useState(0)
  const [isLoading, setIsLoading] = useState(false)

  const onChangeEmail1 = (e) => {
    setEmail1(e.target.value)
  }

  const onChangeEmail2 = (e) => {
    setEmail2(e.target.value)
  }

  const onChangeNaam = (e) => {
    setNaam(e.target.value)
  }

  const onChangeEMAlert = (e) => {
    setEMAlert(e.target.checked)
  }

  const onChangealgVW = (e) => {
    setAlgVW(e.target.checked)
  }

  const onChangeDiscount = (e) => {
    setDiscountCode(e.target.value)
    setCouponError("")
  }

  const validateEmail = (email) => {
    var re = /\S+@\S+\.\S+/
    return re.test(email)
  }

  const handleDeleteCoupon = (e) => {
    e.preventDefault()
    setDiscountCode("")
    setDiscountAmount(0)
  }

  const handleCouponCheck = async (e) => {
    e.preventDefault()
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKENDURL + "/payments/discount/checkdiscount",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            code: discountCode,
          }),
        }
      )
      const responseData = await response.json()
      if (!response.ok) {
        language === "NL"
          ? setCouponError(
              "Er is iets fout gegaan op onze servers. Probeer het nog eens."
            )
          : setCouponError(
              "Something went wrong on our servers. Please try again."
            )
      }
      if (responseData.success) {
        setDiscountAmount(responseData.discountAmount)
      } else if (responseData.alreadyUsed) {
        language === "NL"
          ? setCouponError("Deze kortingscode is al gebruikt")
          : setCouponError("This promo code has already been used")
      } else {
        language === "NL"
          ? setCouponError("Deze kortingscode is niet geldig")
          : setCouponError("This promo code is not valid")
      }
    } catch (err) {
      language === "NL"
        ? setCouponError(
            "Er is iets fout gegaan op onze servers. Probeer het nog eens."
          )
        : setCouponError(
            "Something went wrong on our servers. Please try again."
          )
    }
  }

  const handleClickAfrekenen = (e) => {
    e.preventDefault()
    setError("")
    const emailsEqual = email1 === email2
    const email1Valid = validateEmail(email1)

    // Check if data is valid
    if (email1.length === 0) {
      language === "NL"
        ? setError("Voer een e-mailadres in")
        : setError("Enter an e-mail address")
      return
    } else if (!emailsEqual) {
      language === "NL"
        ? setError("De e-mailadressen komen niet overeen")
        : setError("The e-mail addresses don't match")
      return
    } else if (!email1Valid) {
      language === "NL"
        ? setError("Dit e-mailadres lijkt niet te kloppen")
        : setError("This e-mail address doesn't look right")
      return
    } else if (!algVW) {
      language === "NL"
        ? setError("Ga akkoord met de algemene voorwaarden om verder te gaan")
        : setError("Please accept the terms and conditions to continue")
      return
    }

    // Get payment URL from backend and create new order
    const getData = async () => {
      setIsLoading(true)
      try {
        const response = await fetch(
          process.env.REACT_APP_BACKENDURL + "/payments/orders/createorder",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              email: email1,
              escaperoom: id,
              naam: naam,
              EMAlert: EMAlert,
              code: discountCode,
            }),
          }
        )
        const responseData = await response.json()
        if (!response.ok) {
          language === "NL"
            ? setError(
                "Er is iets fout gegaan op onze servers. Probeer het nog eens."
              )
            : setError("Something went wrong on our servers. Please try again.")
        }
        if (responseData.success) {
          // Redirect to payment URL or to completion page if free order
          setIsLoading(false)
          window.location.href = responseData.redirectUrl
        } else {
          language === "NL"
            ? setError(
                "Er is iets fout gegaan op onze servers. Probeer het nog eens."
              )
            : setError("Something went wrong on our servers. Please try again.")
        }
        setIsLoading(false)
      } catch (err) {
        setIsLoading(false)
        language === "NL"
          ? setError(
              "Er is iets fout gegaan op onze servers. Probeer het nog eens."
            )
          : setError("Something went wrong on our servers. Please try again.")
      }
    }
    getData()
  }

  // An old or mistyped link
  if (!room) {
    return <PageNotFound />
  }

  const nl = language === "NL"
  const name = nl ? title : titleEN
  const total = Math.max(0, price - discountAmount)

  return (
    <main className="page pay-page">
      <style>
        {`.${id}-background-color {background-color: ${themeColor};}`}
      </style>
      <Helmet>
        <title>
          {nl ? `Afrekenen ${title}` : `Checkout ${titleEN}`} | Escape Mystery
        </title>
      </Helmet>

      <div className="page-intro">
        <h1>{nl ? "Afrekenen" : "Checkout"}</h1>
        <p>
          {nl
            ? "Na het betalen krijg je de toegangscode direct per e-mail."
            : "After paying you get the access code by e-mail right away."}
        </p>
      </div>

      <form
        className="page-content checkout"
        onSubmit={handleClickAfrekenen}
        noValidate
      >
        <aside className="checkout-card order-summary">
          <h2>{nl ? "Jouw bestelling" : "Your order"}</h2>
          <div className="order-product">
            <img
              src={require(`../EscaperoomsPage/img/${picName}`).default}
              alt=""
            />
            <div>
              <p className="order-product-name">{name}</p>
              <p className="order-product-meta">
                {nl
                  ? `Toegangscode · team van ${players} personen`
                  : `Access code · team of ${players} people`}
              </p>
            </div>
          </div>

          <label className="field-label" htmlFor="coupon">
            {nl ? "Kortingscode" : "Promo code"}
          </label>
          <div className="flex-input-button">
            <input
              type="text"
              id="coupon"
              autoComplete="off"
              value={discountCode}
              onChange={onChangeDiscount}
              onKeyDown={(e) => {
                // Enter applies the code instead of paying
                if (e.key === "Enter" && discountAmount === 0) {
                  e.preventDefault()
                  if (discountCode.length > 0) handleCouponCheck(e)
                }
              }}
              disabled={discountAmount > 0}
            />
            {discountAmount > 0 ? (
              <button
                type="button"
                className="secondary-button"
                onClick={handleDeleteCoupon}
              >
                {nl ? "Verwijderen" : "Remove"}
              </button>
            ) : (
              <button
                type="button"
                className="secondary-button"
                disabled={discountCode.length === 0}
                onClick={handleCouponCheck}
              >
                {nl ? "Toevoegen" : "Apply"}
              </button>
            )}
          </div>
          {couponError && (
            <p className="field-error" role="alert">
              {couponError}
            </p>
          )}

          <dl className="order-lines">
            <div>
              <dt>{nl ? "Prijs" : "Price"}</dt>
              <dd>€ {price},00</dd>
            </div>
            {discountAmount > 0 && (
              <div className="order-discount">
                <dt>{nl ? "Korting" : "Discount"}</dt>
                <dd>− € {discountAmount},00</dd>
              </div>
            )}
            <div className="order-total">
              <dt>{nl ? "Totaal" : "Total"}</dt>
              <dd>€ {total},00</dd>
            </div>
          </dl>
        </aside>

        <div className="checkout-card checkout-details">
          <h2>{nl ? "Jouw gegevens" : "Your details"}</h2>

          <label className="field-label" htmlFor="email1">
            {nl ? "E-mailadres" : "E-mail address"}
          </label>
          <input
            type="email"
            id="email1"
            autoComplete="email"
            aria-describedby="email-hint"
            value={email1}
            onChange={onChangeEmail1}
          />
          <p className="field-hint" id="email-hint">
            {nl
              ? "Hier sturen we de toegangscode naartoe, dus check even of hij klopt."
              : "We send the access code here, so double-check it."}
          </p>

          <label className="field-label" htmlFor="email2">
            {nl ? "Herhaal e-mailadres" : "Repeat e-mail address"}
          </label>
          <input
            type="email"
            id="email2"
            autoComplete="email"
            value={email2}
            onChange={onChangeEmail2}
          />

          <label className="field-label" htmlFor="naam_input">
            {nl ? "Naam" : "Name"}{" "}
            <span className="optional">{nl ? "(optioneel)" : "(optional)"}</span>
          </label>
          <input
            type="text"
            id="naam_input"
            autoComplete="name"
            value={naam}
            onChange={onChangeNaam}
          />

          <label className="check-row" htmlFor="EMalert">
            <input
              type="checkbox"
              id="EMalert"
              checked={EMAlert}
              onChange={onChangeEMAlert}
            />
            <span>
              {nl
                ? "Mail me als er een nieuwe escape room uitkomt"
                : "E-mail me when a new escape room comes out"}
            </span>
          </label>

          <label className="check-row" htmlFor="algvw">
            <input
              type="checkbox"
              id="algvw"
              checked={algVW}
              onChange={onChangealgVW}
            />
            <span>
              {nl ? "Ik ga akkoord met de " : "I agree to the "}
              <a href="/voorwaarden" target="_blank" rel="noreferrer">
                {nl ? "algemene voorwaarden" : "terms and conditions"}
              </a>
            </span>
          </label>

          {error && (
            <p className="field-error" role="alert">
              {error}
            </p>
          )}

          <button
            type="submit"
            className={`blue-button pay-button ${id}-background-color`}
            disabled={isLoading}
          >
            {isLoading ? (
              <FontAwesomeIcon icon={faSpinner} className="fa-spin" />
            ) : (
              <FontAwesomeIcon icon={faLock} />
            )}
            {nl ? `Betalen · € ${total},00` : `Pay · € ${total},00`}
          </button>
          <p className="pay-note">
            {nl
              ? "Je betaalt veilig via Mollie met iDEAL | Wero, creditcard of Apple Pay."
              : "You pay securely via Mollie with iDEAL | Wero, credit card or Apple Pay."}
          </p>
        </div>
      </form>
    </main>
  )
}

export default PayPage
